<script lang="ts">
  import { browser } from '$app/environment';
  import LazyPicture from '$components/LazyPicture.svelte';
  import getMediaUrl from '$lib/getMediaUrl';
  import getMediaSources from '$lib/getMediaSources';
  import type { ButterflyMedia } from '$lib/types';

  export let lazyload = true;
  export let media: ButterflyMedia | null;
  export let width = 320;
  export let height = Math.floor((768 * width) / 1366);
  export let srcset: { media: string; width: number }[] = [];
  export let alt: string | undefined = undefined;
  export let format: 'default' | 'source' | 'thumb' | 'square' | 'cover' | 'stories' = 'thumb';
</script>

<svelte:head>
  {#if !lazyload && !browser && media}
    <link rel="preload" as="image" href="{getMediaUrl(media, { format, ext: 'jpg', width })}" />
  {/if}
</svelte:head>

{#if lazyload}
  <LazyPicture
    {...$$restProps}
    sources="{getMediaSources(media, srcset, format)}"
    src="{media ? getMediaUrl(media, { format, ext: 'jpg', width }) : '/thumb.jpg'}"
    alt="{alt}"
    width="{width}"
    height="{height}"
  />
{:else}
  <picture {...$$restProps}>
    {#each getMediaSources(media, srcset, format) as source}
      <source media="{source.media}" srcset="{source.srcset}" type="{source.type}" />
    {/each}
    <img
      fetchpriority="high"
      loading="eager"
      src="{media ? getMediaUrl(media, { format, ext: 'jpg', width }) : '/thumb.jpg'}"
      alt="{alt}"
      width="{width}"
      height="{height}"
    />
  </picture>
{/if}
